// Salvando a função original fetch
const originalFetch = window.fetch;

// Substituindo a função fetch por uma função customizada
window.fetch = async function (...args) {
  console.log('Interceptando fetch:', args);

  // Chamando a função fetch original
  const response = await originalFetch(...args);

  // Verificando se a URL da requisição contém "bulk_update"
  if (args[0].includes('bulk_update')) {
    console.log('bulk_update detectado, redirecionando...');

    // Aguardando a conclusão da resposta
    response.clone().json().then(data => {
      console.log('Resposta recebida:', data);

      // Obtendo o URL atual da página
      const currentUrl = window.location.href;

      // Condicional para redirecionar com base na origem
      if (currentUrl === 'https://cumbucaboa.com.br/pages/finalize-seu-cadastro') {
        window.location.href = 'https://cumbucaboa.com.br/cart';
      } else if (currentUrl === 'https://cumbucaboa.com.br/pages/complemente-seu-cadastro') {
        window.location.href = 'https://cumbucaboa.com.br/account';
      } else {
        console.log('URL de origem não reconhecida. Nenhum redirecionamento realizado.');
      }
    }).catch(error => {
      console.error('Erro ao processar a resposta:', error);
      // Tentando redirecionar mesmo se a resposta não puder ser processada
      const currentUrl = window.location.href;

      // Condicional para redirecionar com base na origem
      if (currentUrl === 'https://cumbucaboa.com.br/pages/finalize-seu-cadastro') {
        window.location.href = 'https://cumbucaboa.com.br/cart';
      } else if (currentUrl === 'https://cumbucaboa.com.br/pages/complemente-seu-cadastro') {
        window.location.href = 'https://cumbucaboa.com.br/account';
      } else {
        console.log('URL de origem não reconhecida. Nenhum redirecionamento realizado.');
      }
    });
  }

  return response;
};
